/** Keep the existing layout offset contract while two independent reads load. */
export function setAccountBannerHeight(kind: 'primary' | 'registration', height: number) {
    const style = document.documentElement.style;
    style.setProperty(`--${kind}-banner-h`, `${height}px`);
    const total = ['primary', 'registration'].reduce((n, key) =>
        n + (parseFloat(style.getPropertyValue(`--${key}-banner-h`)) || 0), 0);
    style.setProperty('--trial-banner-h', `${total}px`);
}
